module.exports = __webpack_public_path__ + "static/img/business_chair_h9_l.a172b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/business_chair_h9_l.png
// module id = vhOA
// module chunks = 3